import { ChangeDetectorRef, Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppService } from '../../app.service';
import { MoovService } from '../../services/MoovService';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MoovConfiguration } from '../../models/moovConfiguration';
import { MoovDefinition } from '../../models/moovDefinition';
import { MoovDefinitionCustomerAdoption } from '../../models/moovDefinitionCustomerAdoption';
import { take } from 'rxjs';

@Component({ standalone:false,
  selector: 'app-edit-custom-price-dialog',
  templateUrl: './edit-custom-price-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./edit-custom-price-dialog.component.scss']
})
export class EditCustomPriceDialogComponent {
  public title: string = "Edit custom price"
  public cancelButtonText = "CANCEL";
  public submitButtonText = "SAVE CHANGES";
  public moovDefinition:MoovDefinition;
  public moovDefinitionCustomerAdoption:MoovDefinitionCustomerAdoption;
  public moovConfiguration:MoovConfiguration;
  public busy=true;
  public dialogForm:FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private moovService:MoovService, private dialogRef: MatDialogRef<EditCustomPriceDialogComponent>, private snackBar: MatSnackBar, private cd:ChangeDetectorRef) {
    this.moovDefinition = data.moovDefinition;
    this.moovDefinitionCustomerAdoption = data.moovDefinitionCustomerAdoption;
    this.moovConfiguration = data.moovConfiguration;
    this.dialogForm = new FormGroup({
        usagePrice: new FormControl<number | undefined>(undefined, Validators.required),
    });
  }

  ngOnInit() {
    this.populateForm();
  }

  private populateForm(){
    if(this.moovDefinition && this.moovConfiguration && this.moovDefinitionCustomerAdoption){
      let usage;
      let usagePrice;
      if(this.moovDefinitionCustomerAdoption.usageTypeOverride!=undefined){
        usage = this.usageTypeArray.find(u=>u.value==this.moovDefinitionCustomerAdoption.usageTypeOverride);
      }
      else{
        usage = this.usageTypeArray.find(u=>u.value==this.moovDefinition.usageType);
      }
      if(usage?.value===4){
        if(this.moovConfiguration.usagePriceOverride!=undefined){
          usagePrice = this.moovConfiguration.usagePriceOverride;
        }
        else if(this.moovDefinitionCustomerAdoption.usagePriceOverride!=undefined){
          usagePrice = this.moovDefinitionCustomerAdoption.usagePriceOverride;
        }
        else{
          usagePrice = this.moovDefinition.usagePrice;
        }
      }
      this.dialogForm.get('usagePrice')!.setValue(usagePrice);
      this.busy=false;
    }
    else this.busy=false;
  }

  get usageTypeArray(){
    return AppService.usageTypeArray;
  }

  get canSubmit(){
    return !this.busy && this.dialogForm.valid 
  }

  public onSubmitClick(): void {
    this.busy=true;
    this.moovService.updateMoovConfigurationUsagePriceOverride(this.moovConfiguration.id, this.dialogForm.get('usagePrice')!.value).pipe(take(1)).subscribe(r=>{
      if(r.success){
        this.snackBar.open("Billing updated", '×', { panelClass: ['primary-snackbar'], verticalPosition: 'top', duration: 3000 });
        this.moovConfiguration.usagePriceOverride=this.dialogForm.get('usagePrice')!.value;
        this.dialogRef.close(true);
      }
      else{
        this.snackBar.open("Error updating billing: "  + r.message, 'x', { panelClass: ['warn-snackbar'], verticalPosition: 'top' });
      }
      this.busy=false;
      this.cd.detectChanges();
    });
  }

  public onCancelClick(): void {
    this.dialogRef.close(false);
  }

}

